// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh4[data-v-65b7683e] {\n    text-align: center;\n    font-weight: 400;\n    margin-bottom: 4px;\n}\nh5[data-v-65b7683e] {\n    font-size: 1.3rem;\n    text-align: center;\n}\n.parent .avatar[data-v-65b7683e] {\n    display: grid;\n    text-align: center;\n    align-items: center;\n    grid-row-gap: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
